import { UseFormReturn } from 'react-hook-form';
import { PortFormValues } from './usePortForm';
import { PortForm } from './PortForm';

interface SettingsPortPageProps {
  form: UseFormReturn<PortFormValues>;
}

export function SettingsPortPage({ form }: SettingsPortPageProps) {
  return <PortForm form={form} />;
}
